import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { actionGetAtivarAcesso } from "../../features/login-ativar/slices";
import Button from "../../components/Button";
import Input from "../../components/Inputs";
import "../PageLogin/_styles.scss";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
// @ts-ignore: asset import without type declarations
import IkoneLogo from "../../assets/ikone.png";
import { toast } from "sonner";
import { getUser } from "../../helpers/user";
import { InputChange } from "../../global/type";

interface IStatePageAtivarAcesso {
  login: string;
  email: string;
  key: string;
  pass: string;
}

const PageAtivarAcesso = () => {
  const dispatch = useAppDispatch();
  const { status } = useAppSelector((state) => state.getAtivarAcesso);
  const navegate = useNavigate();

  const initialState: IStatePageAtivarAcesso = {
    login: "",
    email: "",
    key: "",
    pass: "",
  };

  const [state, setState] = React.useState(initialState);

  const handlerAtivarAcesso = async (ev: React.FormEvent<HTMLInputElement>) => {
    ev.preventDefault();

    if (state.email === "" || state.key === "" || state.pass === "") {
      toast.error("Preencha todos os campos");
      return;
    }

    if (
      !state.email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
    ) {
      toast.error("Email inválido");
      return;
    }

    try {
      await dispatch(actionGetAtivarAcesso(state)).unwrap();
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const handlerChange = (ev: InputChange) => {
    const { name, value } = ev.currentTarget;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlerCancelar = (ev: InputChange) => {
    ev.preventDefault();
    navegate("/");
  };

  React.useEffect(() => {
    if (status === "idle") return;

    if (status === "error") {
      toast.error("Falha ao ativar o acesso. Verifique os dados informados.");
    }

    if (status === "success") {
      toast.success("Acesso ativado com sucesso");
      navegate("/");
    }

    return () => {};
  }, [status, navegate]);

  const user = getUser();

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="page-login">
      <form className="form-login">
        <h1 className="text-center heading--md mb-10">Ativar Acesso</h1>
        <div className="form-login__inputs">
          <Input
            type="text"
            name="email"
            label="Email"
            size="sm"
            placeholder=""
            onChange={handlerChange}
          />
          <Input
            type="text"
            name="key"
            label="Chave"
            size="sm"
            placeholder=""
            onChange={handlerChange}
          />
          <Input
            type="password"
            name="pass"
            label="Senha"
            size="sm"
            placeholder=""
            onChange={handlerChange}
          />
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            size="sm"
            variant="primary"
            onClick={handlerAtivarAcesso}
            loading={status === "loading"}
          >
            Ativar Acesso
          </Button>
          <Button size="sm" variant="secondary" onClick={handlerCancelar}>
            Cancelar/Voltar
          </Button>
        </div>
      </form>

      <div className="page-login__footer">
        <p>desenvolvido por</p>
        <img src={IkoneLogo} alt="Logotipo da Ikone" />
      </div>
    </div>
  );
};
export default PageAtivarAcesso;
